<template>
  <div>
    <h4><strong>Entrada</strong></h4>
    <div class="panel panel-default">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Porcentagem</th>
            <th>Valor</th>
            <th>Vencimento</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="payment-entry-input">
              <div class="input-group">
                <input
                  type="number"
                  class="form-control js-percentage-input"
                  placeholder="Ex.: 40"
                  v-model="options.percentage"
                  @input="percentageInput()"
                  @change="$emit('change', options)"
                >
                <span class="input-group-addon">%</span>
              </div>
            </td>
            <td class="payment-entry-input">
              <div class="input-group">
                <span class="input-group-addon">R$</span>
                <money
                  v-bind="moneyOptions"
                  class="form-control js-value-input"
                  v-model="options.value"
                  @blur.native="valueInput()"
                  @change.native="$emit('change', options)"
                />
              </div>
            </td>
            <td>
              <div class="datepicker-wrapper">
                <date-picker
                  v-model="options.expiryDate"
                  placeholder="Data de vencimento"
                  class="js-date-input"
                  :config="datePickerOptions"
                  @change.native="$emit('change', options)"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import 'moment/locale/pt-br';
import DatePicker from 'vue-bootstrap-datetimepicker';
import datePickerOptions from 'utils/DatePickerOptions';
import { Money } from 'v-money';
import moneyOptions from 'utils/MoneyOptions';

export default {
  components: {
    DatePicker,
    Money,
  },
  props: {
    fullValue: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      options: {
        percentage: null,
        value: 0.0,
        expiryDate: null,
      },
      moneyOptions,
      datePickerOptions,
    };
  },
  methods: {
    percentageInput() {
      this.options.value = (this.fullValue / 100.0) * this.options.percentage;
    },
    valueInput() {
      if (this.fullValue > 0) {
        this.options.percentage = ((parseFloat(this.options.value) / this.fullValue) * 100.0).toFixed(2);
      }
    },
  },
  watch: {
    fullValue() {
      this.percentageInput();
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-entry-input {
  width: 160px;
}

.datepicker-wrapper {
  max-width: 160px;
  position: relative;
}
</style>
